import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import useWizardExit from '@swf/core/hooks/useWizardExit';

import Button from '../../../Button/Button';
import Container from '../../../Container/Container';

import {
  TXTCLI_Error,
  TXTCLI_We_canXt_complete_the_sign_up__ELL,
  TXTCLI_XXBrandXX_Home,
  TXTWCL_Something_went_wrong
} from './SignupError.messages.json';

const SignupError: React.FC = () => {
  const exitWizard = useWizardExit();

  return (
    <Container
      page={SignupError}
      headerProps={{
        title: <Translation {...TXTCLI_Error} />,
        buttons: {
          back: false,
          exitWizardOnBackClick: false,
          onCloseClick: exitWizard
        }
      }}
      pageTopTitle={<Translation {...TXTWCL_Something_went_wrong} />}
      pageTopSubtitle={<Translation {...TXTCLI_We_canXt_complete_the_sign_up__ELL} />}
    >
      <Button tabIndex={0} onClick={exitWizard} translation={TXTCLI_XXBrandXX_Home} />
    </Container>
  );
};

SignupError.displayName = 'SignupError';

export default SignupError;
